import React, { Component } from 'react';

export default class Services extends Component {
    state={
        click:true,
        paraClassWEB:'description-para-WEB',
        myparaClassWEB:'mydescription-para-hidden-WEB',
        buttonDescriptionWEB:'Learn more',


        paraClassUI:'description-para-UI',
        myparaClassUI:'mydescription-para-hidden-UI',
        buttonDescriptionUI:'Learn more',


        paraClassAPP:'description-para-APP',
        myparaClassAPP:'mydescription-para-hidden-APP',
        buttonDescriptionAPP:'Learn more',


        paraClassDEV:'description-para-DEV',
        myparaClassDEV:'mydescription-para-hidden-DEV',
        buttonDescriptionDEV:'Learn more',


    }
                                            /*WEB DEVELOPMENT */   
    changeParaWEB=()=>{
        console.log('click');
        this.state.click?
        this.setState({
            click:false,
            paraClassWEB:'description-para-hidden-WEB',
            myparaClassWEB:'mydescription-para-WEB',
            buttonDescriptionWEB:'Back to description',
        }):
        
        this.setState({
            click:true,
            paraClassWEB:'description-para-WEB',
            myparaClassWEB:'mydescription-para-hidden-WEB',
            buttonDescriptionWEB:'Learn more',
        })

    }
                                            /*UI/UX DEVELOPMENT */   
    changeParaUI=()=>{
        console.log('click');
        this.state.click?
        this.setState({
            click:false,
            paraClassUI:'description-para-hidden-UI',
            myparaClassUI:'mydescription-para-UI',
            buttonDescriptionUI:'Back to description',
        }):
        
        this.setState({
            click:true,
            paraClassUI:'description-para-UI',
            myparaClassUI:'mydescription-para-hidden-UI',
            buttonDescriptionUI:'Learn more',
        })

    }
                                            /*APP DEVELOPMENT */              
    changeParaAPP=()=>{
        console.log('click');
        this.state.click?
        this.setState({
            click:false,
            paraClassAPP:'description-para-hidden-APP',
            myparaClassAPP:'mydescription-para-APP',
            buttonDescriptionAPP:'Back to description',
        }):
        
        this.setState({
            click:true,
            paraClassAPP:'description-para-APP',
            myparaClassAPP:'mydescription-para-hidden-APP',
            buttonDescriptionAPP:'Learn more',
        })
    }
                                            /*DEV DEVELOPMENT */              
    changeParaDEV=()=>{
        console.log('click');
        this.state.click?
        this.setState({
            click:false,
            paraClassDEV:'description-para-hidden-DEV',
            myparaClassDEV:'mydescription-para-DEV',
            buttonDescriptionDEV:'Back to description',
        }):
        
        this.setState({
            click:true,
            paraClassDEV:'description-para-DEV',
            myparaClassDEV:'mydescription-para-hidden-DEV',
            buttonDescriptionDEV:'Learn more',
        })
    }
                                        /* THE CODE STARTS HERE */
    render() {
        return (
            <div id="services-page" className='services'>
            <h1 className='small-headline-services'>Services</h1>
            <div className='service-container'>
            
                <div className='service-page'>

                {/*WEB DEVELOPMENT */}
                    <div className='box'>
                    <div className='box2'></div>
                        <div className='content'>
                            <h2>01</h2>
                            <h3> Web development</h3>

                            <p className={this.state.paraClassWEB}>A website sets an impression about 
                            the brand. It must be built with two primary goals: 
                            First it needs to work with all devices. 
                            Secondly it needs to be fast.
                            </p>

                            <p className={this.state.myparaClassWEB}>
                            <em className='subheading'>TECHNOLOGIES:</em><br/> HTML, CSS, JS, REACT JS, JSON,
                            REDUX, NODEJS, FIREBASE, MONGODB, EXPRESS JS, SQL,
                            GATBSYJS, CONTENTFUL, BOOTSTRAP, GRAPHQL
                            <br/>
                            </p>

                            <a onClick={this.changeParaWEB}>{this.state.buttonDescriptionWEB}</a>
                        </div>
                    </div>

                {/*UI/UX DEVELOPMENT */}
                    <div className='box'>
                    <div className='box2'></div>
                        <div className='content'>
                            <h2>02</h2>
                            <h3>UI/UX designing</h3>

                            <p className={this.state.paraClassUI}>An application should be designed for the people who will use it, 
                            so that's exactly what I do. User focused design should be 
                            the primary goal of any application.</p>

                            <p className={this.state.myparaClassUI}>
                            <em className='subheading'>TECHNOLOGIES: </em><br/>
                            ADOBE XD, FIGMA, ADOBE ILLUSTRATOR.
                            <br/>
                            <em className='subheading'>PROJECTS: </em>
                            WIREFRAME FOR
                            M-INDICATOR, PHOTO SHARING APP, PORTFOLIO WEBSITE.
                            </p>
                            <a onClick={this.changeParaUI}>{this.state.buttonDescriptionUI}</a>
                        </div>
                    </div>

                {/*APP DEVELOPMENT */}
                    <div className='box'>
                    <div className='box2'></div>
                        <div className='content'>
                            <h2>03</h2>
                            <h3>App development</h3>


                            <p className={this.state.paraClassAPP}>Mobiles are not just devices they are the basic needs,
                            to bring out everything out of your mobile phones and make 
                            the job easier mobile apps come into play.</p>


                            <p className={this.state.myparaClassAPP}>
                            <em className='subheading'>TECHNOLOGIES: </em>
                            ANDROID STUDIO, REACT NATIVE.
                            <br/>
                            <em className='subheading'>PROJECTS: </em>
                            TO-DO APPLICATION, MUSIC PLAYER, CALL RECORDER, 
                            PHOTO SHARING APPLICATION.
                            </p>

                            <a onClick={this.changeParaAPP}>{this.state.buttonDescriptionAPP}</a>
                        </div>
                    </div>

                {/*DEV DEVELOPMENT */}
                    <div className='box'>
                    <div className='box2'></div>
                        <div className='content'>
                            <h2>04</h2>
                            <h3>Development</h3>


                            <p className={this.state.paraClassDEV}>Experience in more than one programming language. like Python, 
                            Javascript, Java & C/C++. Also familiar with tools like 
                            MATLAB, Android studio, Adobe Illustrator, Firebase.</p>

                            <p className={this.state.myparaClassDEV}>
                            <em className='subheading'>TECHNOLOGIES: </em>
                            C/C++,JAVA,PYTHON,
                            <br/>JAVASCRIPT,MATLAB.<br/>
                            <em className='subheading'>PROJECTS: </em>
                            SIGNATURE VERIFICATION, L.I.F.I, TEXT TO SPEECH, SPEECH TO TEXT, OBJECT IDENTIFICATION
                            </p>

                            <a onClick={this.changeParaDEV}>{this.state.buttonDescriptionDEV}</a>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
}
